import { jsx as _jsx } from "react/jsx-runtime";
import Grid from '../Grid';
const FormRaw = ({ children, ...rest }) => (_jsx(Grid, { item: true, ...rest, children: children }));
export { FormRaw };
